import React from 'react';
import styles from './styles/userDataBody.module.css';
import { CiImageOff } from 'react-icons/ci';
import { MdOutlineEdit } from 'react-icons/md';
import LicenseTable from './LicenseTable';

interface BodyInterface {
  hireDate: string;
  onEditClick?: () => void; // optional
}

const UserDataBody: React.FC<BodyInterface> = ({ hireDate, onEditClick }) => {
  return (
    <div className={styles.userDataBodyWrapper}>
      <div className={styles.leftDisplay}>
        <div className={styles.profileCard}>
          <div className={styles.profileCardTop}>
            {/* Flip container */}
            <div
              className={styles.imageFlip}
              aria-label="Profile image placeholder"
            >
              <div className={styles.flipInner}>
                {/* FRONT: placeholder */}
                <div className={`${styles.flipFace} ${styles.flipFront}`}>
                  <CiImageOff className={styles.placeholderIcon} />
                </div>
                {/* BACK: edit pen with same styling */}
                <button
                  type="button"
                  className={`${styles.flipFace} ${styles.flipBack}`}
                  onClick={onEditClick}
                  aria-label="Edit profile image"
                >
                  <MdOutlineEdit className={styles.placeholderIcon} />
                </button>
              </div>
            </div>
          </div>

          <p className={styles.hireDate}>{`Hire Date: ${hireDate}`}</p>
          <p className={styles.complianceAlerts}>Compliance Alerts:</p>
        </div>
      </div>

      <div className={styles.rightDisplay}>
        <LicenseTable />
      </div>
    </div>
  );
};

export default UserDataBody;
